import axios from 'axios';
import { cmsUrl } from '../../variables';

export default {
    loadAllOfferings(context) {
        axios
            .get(cmsUrl + '/offers')
            .then(data => context.commit('loadAllOffersSuccess', data.data))
            .catch(err => context.commit('loadAllOffersError', err))
    },
    loadAllOfferingCategories(context) {
        axios
            .get(cmsUrl + '/offer_categories')
            .then(data => context.commit('loadAllOfferCategoriesSuccess', data.data))
            .catch(err => context.commit('loadAllOfferCategoriesError', err))
    },
    loadAllOfferingLocations(context) {
        axios
            .get(cmsUrl + '/offer_locations')
            .then(data => context.commit('loadAllOfferLocationsSuccess', data.data))
            .catch(err => context.commit('loadAllOfferLocationsError', err))
    },

};